import { Divider, Theme, SxProps } from '@mui/material';

type VyDividerProps = {
  orientation?: 'horizontal' | 'vertical';
  flexItem?: boolean;
  sx?: SxProps<Theme>;
};

export const VyDivider = ({ orientation = 'horizontal', flexItem, sx }: VyDividerProps) => (
  <Divider orientation={orientation} flexItem={flexItem} sx={sx} />
);
